import Vue      from 'vue'
import App      from './App.vue'
import router   from './router'
import store    from './store'
import axios    from './AxiosHandler'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-date-pick/dist/vueDatePick.css';
import './assets/css/main.css'
import VueCookies           from 'vue-cookies'
import VCalendar            from 'v-calendar';
import Loading              from './components/shared/Loading'
import LoadingIcon          from './components/shared/LoadingIcon'
import MultiSelect          from './components/shared/inputs/MultiSelect'
import SingleSelect          from './components/shared/inputs/SingleSelect'

import ClassicEditor        from '@ckeditor/ckeditor5-build-classic'
import VueCkeditor          from 'vue-ckeditor5'
import Vuelidate            from 'vuelidate'
import { i18n }             from './plugins/i18n'
import CurrencyFilter       from './filters/currency'
import NettoFilter          from './filters/netto'
import DateFilter           from './filters/date'

import { library }          from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon }  from '@fortawesome/vue-fontawesome'
import { 
    faEnvelope, 
    faEnvelopeOpen, 
    faTimesCircle, 
    faCircleNotch, 
    faSignOutAlt, 
    faSearch, 
    faChevronCircleDown, 
    faChevronCircleUp,
    faChevronDown,
    faChevronUp,
    faComment,
    faCalendarAlt,
    faFilter,
    faArrowCircleLeft,
    faHome,
    faMinusCircle,
    faLock,
    faLockOpen,
    faEdit,
    faSquare, 
    faCheckSquare,
    faBars,
    faChartLine,
    faTable,
    faBell,
    faStar,
    faStarHalfAlt,
    faEye,
    faEyeSlash,
    faPaperPlane,
    faTimes,
    faCheck,
    faPlay,
    faPause,
    faTrashAlt,
    faCopy,
    faHighlighter,
    faQuestionCircle,
    faCrop
} from '@fortawesome/free-solid-svg-icons';
import { faSquare as farSquare, faCheckSquare as farCheckSquare, faStar as farStar } from '@fortawesome/free-regular-svg-icons';


const options = {
    editors: {
        classic: ClassicEditor,
    },
    name: 'ckeditor',
}



Vue.config.productionTip = false

Vue.prototype.$http = axios;
Vue.prototype.FORCE_UPDATE = true;
Vue.prototype.LAZY_UPDATE  = false;

Vue.config.devtools = process.env.VUE_APP_MODE == 'development' ? true : false;
Vue.config.devtools = true;

Vue.filter('currency', CurrencyFilter);
Vue.filter('netto', NettoFilter);
Vue.filter('date', DateFilter);

Vue.use(VueCkeditor.plugin, options);
Vue.use(BootstrapVue);
Vue.use(VueCookies);
Vue.use(Vuelidate);
Vue.use(VCalendar, {
    theme: {
        color: 'green'
    },
    screens: {
        tablet: '576px',
        laptop: '992px',
        desktop: '1200px',
    }
});

library.add(
    faEnvelope, 
    faEnvelopeOpen, 
    faTimesCircle, 
    faCircleNotch, 
    faSignOutAlt, 
    faSearch, 
    faChevronCircleDown, 
    faChevronCircleUp, 
    faFilter,
    faChevronDown,
    faChevronUp,
    faComment,
    faCalendarAlt,
    faCheckSquare,
    faSquare,
    faArrowCircleLeft,
    faHome,
    faMinusCircle,
    faLock,
    faLockOpen,
    faEdit,
    faBars,
    farSquare,
    farCheckSquare,
    faChartLine,
    faTable,
    faBell,
    faStar,
    faStarHalfAlt,
    farStar,
    faEye,
    faEyeSlash,
    faPaperPlane,
    faTimes,
    faCheck,
    faPlay,
    faPause,
    faTrashAlt,
    faCopy,
    faHighlighter,
    faQuestionCircle,
    faCrop
);

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('loading', Loading);
Vue.component('loading-icon', LoadingIcon);
Vue.component('multi-select', MultiSelect);
Vue.component('single-select', SingleSelect);


new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
